export function EmbedIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7.78 7.625a1 1 0 00-1.56-1.25L2.231 11.36a.995.995 0 00-.137 1.066.992.992 0 00.137.214l3.987 4.985a1 1 0 001.562-1.25L4.28 12l3.5-4.375zm10-1.25a1 1 0 00-1.56 1.25L19.72 12l-3.5 4.375a1 1 0 001.56 1.25l3.988-4.985A.987.987 0 0022 12a.995.995 0 00-.232-.64l-3.987-4.985z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
